import { timeStampToDateAndTime } from "../../../../../functions/dateTime/timeStampToDateAndTime";

const CheckpointView = ({ checkpointsData = [], status, stageId }) => {
  return (
    <>
      {checkpointsData.length > 0 ? (
        checkpointsData.map((cp) => {
          return (
            <div key={cp.id} className="bg-[#4b3ba71c] rounded-lg p-3 mb-3">
              <div className="flex justify-between items-center">
                <p className="font-figtreeBold">{cp.checkpoint.name}</p>

                <p className="capitalize">{getFinalValue(cp.resultVal)}</p>
              </div>
              <div className="flex justify-between pt-2 mt-3 text-gray-600 text-xs border-t-1 border-gray-300">
                <p>Checked By : {cp.updatedBy.fullName}</p>
                <p>Date : {timeStampToDateAndTime(cp.updatedAt)}</p>
              </div>
            </div>
          );
        })
      ) : stageId === 6 && status === 1 ? (
        <p className="text-sm text-center mt-3 text-blue-50">
          Hydro testing performed is not required!
        </p>
      ) : (
        <p className="text-sm text-center mt-3 text-gray-500">
          No Checkpoints not updated yet!
        </p>
      )}
    </>
  );
};
export default CheckpointView;

function getFinalValue(value) {
  // Number string
  if (!isNaN(value) && value !== "") {
    return `${Number(value)} KG`;
  }

  // Boolean string
  if (value === "true") {
    return "Yes";
  }

  if (value === "false") {
    return "No";
  }

  // Convert snake_case to readable text
  if (typeof value === "string" && value.includes("_")) {
    return value
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  // Default
  return value;
}